import { state } from './state.js';
import { preview } from './preview.js';
import { utils } from './utils.js';

export const stepsMod = {
  _delegationActive: false,

  render() {
    const { steps, trad } = state;
    const selections = state.getSelections();
    const stepsEl = state.elements.stepsEl;

    if (!stepsEl) {
      return;
    }

    stepsEl.innerHTML = steps.map((step, i) => {
      const selected = selections[step.id];
      const stepId = `step-${step.id}`;

      let options = step.options || [];
      if (step.use_filter && step.type !== 'attribute') {
          const prevAttr = steps
              .slice(0, i)
              .reverse()
              .find(s => s.type === 'attribute' && selections[s.id]);

          if (prevAttr) {
              const selectedAttrId = parseInt(selections[prevAttr.id].id_attribute);

              if (selectedAttrId) {
                  options = options.filter(opt =>
                      Array.isArray(opt.attributes) &&
                      opt.attributes.includes(selectedAttrId)
                  );
              }
          }
      }

      const noneOption = !step.required && step.type !== 'attribute'
        ? `
          <div class="acpb-option-card ${!selected ? 'is-selected' : ''}"
               data-step-id="${step.id}"
               data-step-type="${step.type}"
               data-id-step-option="0"
               data-label="${trad.none}"
               data-price="0"
               data-stock="999999">
            <img src="${prestashop.urls.base_url}modules/ac_packbuilder/views/img/other/no-selection.webp" alt="${trad.none}">
            <div class="acpb-option-label">${trad.none}</div>
          </div>`
        : '';

      return `
        <div class="acpb-step" data-step-index="${i}">
          <div class="acpb-step-header" data-toggle="${stepId}">
            <div class="acpb-step-header-left">
              <span class="acpb-step-index">${trad.step} ${i + 1}</span>
            </div>
           <div class="acpb-step-center">
              <h3>${step.name || ''} ${step.required ? '<span class="acpb-required">*</span>' : ''}</h3>
              ${selected ? `<span class="acpb-selected-option">${selected.label}</span>` : ''}
              ${step.description ? `<div class="acpb-step-description">${step.description}</div>` : ''}
            </div>
            <div class="acpb-step-header-right">
              <span class="acpb-chevron icon-chevron-down"></span>
            </div>
          </div>

          <div class="acpb-step-body" id="${stepId}">
            <div class="acpb-options-grid">
              ${noneOption}
              ${options.map(opt => `
                <div class="acpb-option-card
                  ${selected?.id_step_option === opt.id_step_option ? 'is-selected' : ''}
                  ${step.type === 'product' && opt.stock == 0 ? 'acpb-outofstock' : ''}"
                  data-step-id="${step.id}"
                  data-step-type="${step.type}"
                  data-id-step-option="${opt.id_step_option}"
                  data-id-product="${opt.id_product || ''}"
                  data-id-product-attribute="${opt.id_product_attribute || ''}"
                  data-image="${opt.image || ''}"
                  data-image-webp="${opt.image_webp || ''}"
                  data-image-avif="${opt.image_avif || ''}"
                  data-id-attribute="${opt.id_attribute || ''}"
                  data-id-attribute-group="${opt.id_attribute_group || ''}"
                  data-label="${opt.label}"
                  data-price="${opt.price}"
                  data-stock="${opt.stock}"
                  data-fullname="${utils.stripHtml(step.name + ' - (' + opt.label + ')')}"
                >

                  ${
                    opt.thumb
                      ? opt.thumb.includes('custom_attribute')
                        ? (() => {
                            const base = opt.thumb.replace(/\.[^.]+$/, '');
                            return `
                              <picture>
                                <source srcset="${base}.avif" type="image/avif">
                                <source srcset="${base}.webp" type="image/webp">
                                <img src="${opt.thumb}" alt="${opt.label}">
                              </picture>
                            `;
                          })()
                        : `
                          <img src="${opt.thumb}" alt="${opt.label}">
                        `
                      : opt.image
                        ? `
                          <picture>
                            ${opt.image_avif ? `<source srcset="${opt.image_avif}" type="image/avif">` : ''}
                            ${opt.image_webp ? `<source srcset="${opt.image_webp}" type="image/webp">` : ''}
                            <img src="${opt.image}" alt="${opt.label}">
                          </picture>
                        `
                        : ''
                  }

                  <div class="acpb-option-label">${opt.label}</div>
                  ${opt.price ? `<div class="acpb-option-price">
                    ${step.required ? '' : '+'}${opt.price.toFixed(2)} €
                    </div>` : ''
                  }
                </div>
              `).join('')}
            </div>
          </div>
        </div>`;
    }).join('');

    this.attachDelegatedListeners();
    utils.updateAddButtonState();
  },

  updateUI() {
      const selections = state.getSelections();
      state.steps.forEach(step => {
          const sel = selections[step.id] || null;

          const cards = document.querySelectorAll(`.acpb-option-card[data-step-id="${step.id}"]`);
          cards.forEach(card => card.classList.remove("is-selected"));

          if (sel) {
              const selectedCard = document.querySelector(
                  `.acpb-option-card[data-step-id="${step.id}"][data-id-step-option="${sel.id_step_option}"]`
              );
              selectedCard?.classList.add("is-selected");
          } else {
              const noneCard = document.querySelector(
                  `.acpb-option-card[data-step-id="${step.id}"][data-id-step-option="0"]`
              );
              noneCard?.classList.add("is-selected");
          }

          const header = document.querySelector(`.acpb-step-header[data-toggle="step-${step.id}"]`);
          if (!header) return;

          let span = header.querySelector(".acpb-selected-option");

          if (sel) {
              if (span){
                span.textContent = sel.label;
              } else {
                const desc = header.querySelector(".acpb-step-description");
                if (desc) {
                    desc.insertAdjacentHTML("beforebegin", `<span class="acpb-selected-option">${sel.label}</span>`);
                } else {
                   header.querySelector(".acpb-step-center")
                    .insertAdjacentHTML("beforeend", `<span class="acpb-selected-option">${sel.label}</span>`);
                }
              }
          } else {
              if (span) span.remove();
          }
      });
  },

  renderStep(step)
  {
    const selections = state.getSelections();
    const selected = selections[step.id];
    const stepId = `step-${step.id}`;
    let options = step.options || [];

    if (step.use_filter && step.type !== 'attribute') {
        const steps = state.steps;
        const stepIndex = steps.findIndex(s => s.id === step.id);

        const prevAttr = steps
            .slice(0, stepIndex)
            .reverse()
            .find(s => s.type === 'attribute' && selections[s.id]);

        if (prevAttr) {
            const selectedAttrId = parseInt(selections[prevAttr.id].id_attribute, 10);
            if (selectedAttrId) {
                options = options.filter(opt =>
                    Array.isArray(opt.attributes) &&
                    opt.attributes.includes(selectedAttrId)
                );
            }
        }
    }

    const block = document.querySelector(`#${stepId} .acpb-options-grid`);
    if (!block) return;

    block.innerHTML = options.map(opt => `
        <div class="acpb-option-card
            ${selected?.id_step_option === opt.id_step_option ? 'is-selected' : ''}"
            data-step-id="${step.id}"
            data-step-type="${step.type}"
            data-id-step-option="${opt.id_step_option}"
            data-id-product="${opt.id_product || ''}"
            data-id-product-attribute="${opt.id_product_attribute || ''}"
            data-image="${opt.image || ''}"
            data-image-webp="${opt.image_webp || ''}"
            data-image-avif="${opt.image_avif || ''}"
            data-id-attribute="${opt.id_attribute || ''}"
            data-id-attribute-group="${opt.id_attribute_group || ''}"
            data-label="${opt.label}"
            data-price="${opt.price}"
            data-stock="${opt.stock}"
            data-fullname="${utils.stripHtml(step.name + ' - (' + opt.label + ')')}"
            >
            ${
              opt.thumb
                ? opt.thumb.includes('custom_attribute')
                  ? (() => {
                      const base = opt.thumb.replace(/\.[^.]+$/, '');
                      return `
                        <picture>
                          <source srcset="${base}.avif" type="image/avif">
                          <source srcset="${base}.webp" type="image/webp">
                          <img src="${opt.thumb}" alt="${opt.label}">
                        </picture>
                      `;
                    })()
                  : `
                    <img src="${opt.thumb}" alt="${opt.label}">
                  `
                : opt.image
                  ? `
                    <picture>
                      ${opt.image_avif ? `<source srcset="${opt.image_avif}" type="image/avif">` : ''}
                      ${opt.image_webp ? `<source srcset="${opt.image_webp}" type="image/webp">` : ''}
                      <img src="${opt.image}" alt="${opt.label}">
                    </picture>
                  `
                  : ''
            }

            <div class="acpb-option-label">${opt.label}</div>
            ${opt.price ? `<div class="acpb-option-price">${opt.price.toFixed(2)} €</div>` : ''}
        </div>
    `).join('');
  },


  attachDelegatedListeners() {
    if (this._delegationActive) return;
    this._delegationActive = true;

    const root = state.root;
    if (!root) return;

    root.addEventListener('click', (e) => {
      const header = e.target.closest('.acpb-step-header');
      if (!header) return;

      const stepsEl = state.elements.stepsEl;
      if (!stepsEl) return;

      const target = stepsEl.querySelector('#' + header.dataset.toggle);
      if (!target) return;

      e.stopPropagation();
      e.preventDefault();

      const wasOpen = target.classList.contains('open');
      stepsEl.querySelectorAll('.acpb-step-body').forEach(b => b.classList.remove('open'));
      if (!wasOpen) target.classList.add('open');

      stepsEl.querySelectorAll('.acpb-step-header').forEach(h => {
        const body = stepsEl.querySelector('#' + h.dataset.toggle);
        const chev = h.querySelector('.acpb-chevron');
        const isOpen = body && body.classList.contains('open');
        h.classList.toggle('open', isOpen);
        if (chev) chev.classList.toggle('open', isOpen);
      });
    });

    root.addEventListener('click', (e) => {
      const opt = e.target.closest('.acpb-option-card');
      if (!opt) return;

      e.stopPropagation();
      e.preventDefault();

      this.onOptionClick(opt);
    });
  },

  async onOptionClick(optEl) {
    const data = optEl.dataset;

    const stepId = parseInt(data.stepId);
    const idStepOption = parseInt(data.idStepOption, 10);
    const stepType = data.stepType || 'product';
    const isAttribute = stepType === 'attribute';

    const stepsEl = state.elements.stepsEl;
    const wasOpen = stepsEl?.querySelector('.acpb-step-body.open')?.id;

    if (idStepOption === 0) {
      const selections = state.getSelections();

      if (isAttribute) {
        state.switchBranch('default');
      }

      delete selections[stepId];
      this.refresh(wasOpen);
      return;
    }

    if (isAttribute) {
      const rawLabel = data.label || 'default';
      const branchName = rawLabel
        .toString()
        .trim()
        .toLowerCase();
      state.switchBranch(branchName);
    }

    const selections = state.getSelections();
    const newSel = {
      id_step_option: idStepOption,
      id_product: data.idProduct ? parseInt(data.idProduct, 10) : null,
      id_product_attribute: data.idProductAttribute ? parseInt(data.idProductAttribute, 10) : null,
      image: data.image || '',
      image_webp: data.imageWebp || '',
      image_avif: data.imageAvif || '',
      label: data.label || '',
      fullname: data.fullname || '',
      type: stepType,
      price: data.price ? parseFloat(data.price) : 0,
      stock: data.stock ? parseInt(data.stock, 10) : 0,
      id_attribute: data.idAttribute ? parseInt(data.idAttribute, 10) : null,
      id_attribute_group: data.idAttributeGroup ? parseInt(data.idAttributeGroup, 10) : null
    };

    if (newSel.id_product) {
      try {
        const stockRes = await utils.getStock(newSel.id_product, newSel.id_product_attribute);
        if (stockRes && stockRes.success) {
          newSel.stock = stockRes.stock;
          const stepObj = state.steps.find(s => s.id === stepId);
          if (stepObj && Array.isArray(stepObj.options)) {
            const optObj = stepObj.options.find(o => o.id_step_option == newSel.id_step_option);
            if (optObj) {
              optObj.stock = newSel.stock;
            }
          }
        }
      } catch (e) {
        console.error('Erreur récupération stock :', e);
      }
    }

    document.querySelectorAll('.acpb-option-card').forEach(o=>o.classList.remove('is-selected'));
    optEl.classList.add('is-selected');

    selections[stepId] = newSel;
    this.refresh(wasOpen);
  },

  refresh(openId) {
      const selections = state.getSelections();
      preview.render();
      utils.updateTotal();
      utils.updateAddButtonState();
      this.updateUI();

      const attrStep = state.steps.find(s => s.type === 'attribute' && selections[s.id]);
      if (attrStep) {
          let startRefresh = false;
          state.steps.forEach(step => {
              if (step.id === attrStep.id) startRefresh = true;
              else if (startRefresh && step.use_filter && step.type !== 'attribute') {
                  this.renderStep(step);
              }
          });
      }

      if (openId) {
          document.getElementById(openId)?.classList.add("open");
          document
              .querySelector(`.acpb-step-header[data-toggle="${openId}"]`)
              ?.classList.add("open");
      }
  }
};
